import { Tabs, TabsList, TabsTrigger } from '@design-system';
import { COVERAGE_LANE_COPY } from '../lib/copy';
import type { CoverageLane } from '../lib/coverage-lanes';

interface CoverageLanesProps {
  lanes: CoverageLane[];
  value: ConsumerPaymentSchedule;
  onChange: (schedule: ConsumerPaymentSchedule) => void;
}

/** Switches between the three ways to pay, each with what it offers in a few words. */
export function CoverageLaneSwitch({ lanes, value, onChange }: CoverageLanesProps) {
  return (
    <Tabs value={value} onValueChange={next => onChange(next as ConsumerPaymentSchedule)}>
      <TabsList aria-label="Ways to pay" className="grid h-auto w-full grid-cols-1 sm:grid-cols-3">
        {lanes.map(lane => (
          <TabsTrigger
            key={lane.schedule}
            value={lane.schedule}
            disabled={!lane.isAvailable}
            className="flex h-auto flex-col items-start gap-0.5 whitespace-normal px-3 py-2 text-left"
          >
            <span className="font-semibold">
              {COVERAGE_LANE_COPY[lane.schedule].title}
              {lane.schedule === 'tenPay' && <span className="text-muted-foreground font-normal"> · Most Popular</span>}
            </span>
            <span className="text-muted-foreground text-sm font-normal first-letter:uppercase">
              {lane.teaser ?? 'Not available for your age or state'}
            </span>
          </TabsTrigger>
        ))}
      </TabsList>
    </Tabs>
  );
}
